module.exports = __webpack_public_path__ + "fonts/NunitoSans-Italic-VariableFont_YTLC,opsz,wdth,wght.7f24c02.ttf";